import { ConcreteEncodable } from "./ConcreteEncodable";

import { HolidayImplEncoder } from "../../encoder/HolidayImplEncoder";

import * as CubiqTS from "../../index";
import { Holiday } from "../Holiday";

export class HolidayImpl extends ConcreteEncodable implements Holiday {
  public static enType: string = "com.bcdfx.model.calendar.HolidayImpl";

  /*FID=1*/
  public calendarId: CubiqTS.Long | null = null;
  /*FID=2*/
  public date: CubiqTS.StandardDate | null = null;
  /*FID=3*/
  public name: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = HolidayImplEncoder.Instance;
    this.setEncodableType(HolidayImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "HolidayImpl[" +
      "calendarId=" +
      this.calendarId +
      "date=" +
      this.date +
      "name=" +
      this.name +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
